import React from "react";

import Button from "@atlaskit/button";
import { useTranslation } from "react-i18next";

import { Warning } from "./styled";

const Footer = ({
  prompt,
  errorCode,
  setErrorCode,
  onGenerateHandler,
  hasAIchanges,
}) => {
  const { t } = useTranslation();

  if (errorCode) {
    return (
      <Warning>
        {errorCode === 429 ? (
          <span style={{ fontSize: "11px" }}>
            {t("cards-ai.attempts-1")}, <br />
            {t("cards-ai.attempts-2")}
          </span>
        ) : (
          <>
            {t("cards-ai.try-again-1")}
            <br />
            {t("cards-ai.try-again-2")}
          </>
        )}

        {errorCode !== 429 && (
          <Button appearance="subtle" onClick={() => onGenerateHandler(prompt)}>
            {t("regenerate")}
          </Button>
        )}

        <Button appearance="subtle" onClick={() => setErrorCode(false)}>
          {t("clear")}
        </Button>
      </Warning>
    );
  }

  if (prompt) {
    if (prompt.length === 250) {
      return <Warning>{t("cards-ai.limit")}</Warning>;
    }

    if (hasAIchanges) {
      return (
        <Warning>
          {t("cards-ai.changes-1")}
          <br />
          {t("cards-ai.changes-2")}
        </Warning>
      );
    } else {
      return <Warning>{t("cards-ai.overwrite")}</Warning>;
    }
  }

  return <Warning />;
};

export default Footer;
